// Study registry. Add a study by creating src/studies/<slug>.js and importing it here.
import amr from './amr';
import hpv from './hpv';
import pep from './pep';
import opmd from './opmd';
import tobacco from './tobacco';
import sex from './sex';
import age from './age';

export const studies = [amr, hpv, pep, opmd, tobacco, sex, age];
export const studyBySlug = (slug) => studies.find((s) => s.slug === slug) || null;
